import { render, staticRenderFns } from "./MediaAccreditationEvents.vue?vue&type=template&id=1c00b506&scoped=true"
import script from "./MediaAccreditationEvents.vue?vue&type=script&lang=js"
export * from "./MediaAccreditationEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c00b506",
  null
  
)

export default component.exports